import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

import PropTypes from 'prop-types';
import React from 'react';

const SelectField = ({
  invalid,
  onChange,
  onClick,
  optionGroups,
  options,
  placeholder,
  readOnly,
  required,
  style,
  value
}) => {
  const styles = {
    component: Object.assign(
      {},
      {
        WebkitAppearance: 'none',
        boxShadow: 'none',
        outline: 'none',
        borderRadius: BorderRadius.DEFAULT,
        color: Colors.GRAY.hex,
        fontSize: FontSizes.MEDIUM,
        fontWeight: FontWeights.REGULAR,
        lineHeight: '40px',
        height: 40,
        background: '#fff',
        position: 'relative',
        cursor: 'pointer',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: invalid ? Colors.RED.hex : '#ccc',
        backgroundColor: readOnly ? '#f5f5f5' : '#fff',
        backgroundImage: 'none'
      },
      style
    ),
    trigger: {
      backgroundColor: 'transparent',
      border: 'none',
      color: Colors.GRAY.hex,
      fontSize: FontSizes.REGULAR,
      padding: '9px 28px 8px 10px',
      position: 'relative',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      width: '100%',
      cursor: 'pointer',
      zIndex: 1,
      height: 40,
      lineHeight: '1'
    },
    icon: {
      position: 'absolute',
      right: 8,
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: 18,
      fill: Colors.GRAY.hex,
      zIndex: 0
    },
    required: {
      position: 'absolute',
      lineHeight: '1',
      right: 5,
      top: 5,
      color: Colors.RED.hex,
      fontSize: FontSizes.LARGE
    }
  };

  const handleOnChange = e => {
    if (onChange) {
      onChange(e);
    }
  };

  // TODO: Pull focus logic from Input
  // TODO: add onBlur event handler

  return (
    <div onClick={onClick} style={styles.component}>
      <select
        disabled={readOnly}
        onChange={handleOnChange}
        placeholder={placeholder}
        style={styles.trigger}
        value={value}
      >
        {placeholder ? (
          <option disabled={true} value=''>
            {placeholder}
          </option>
        ) : null}
        {optionGroups &&
          optionGroups?.map((group, i) => {
            return (
              <optgroup key={i} label={group?.label || `Group ${i}`}>
                {group?.options?.map((option, i) => {
                  return (
                    <option key={i} value={option?.value}>
                      {option?.label || option?.value}
                    </option>
                  );
                })}
              </optgroup>
            );
          })}
        {options &&
          options?.map((option, i) => {
            return (
              <option key={i} value={option?.value}>
                {option?.label || option?.value}
              </option>
            );
          })}
      </select>
      <i className='mdi mdi-chevron-down' style={styles.icon} />
      {required ? <span style={styles.required}>*</span> : null}
    </div>
  );
};

SelectField.propTypes = {
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  optionGroups: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          label: PropTypes.string
        })
      ).isRequired
    })
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string
    })
  ),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SelectField;
